import { useSyncExternalStore } from "react";

import { impersonation, onImpersonationChange, type ImpersonationState } from "@/services/customer-portal/impersonation";

/** This tab's session acting as a Rai Managed business, or null. Re-renders when it starts, ends or stops working. */
export function useImpersonation(): ImpersonationState | null {
  return useSyncExternalStore(onImpersonationChange, impersonation, () => null);
}
